import { TEXTS } from 'application/pages/PointsPage/renderer/texts';

export const PLAYER_TYPES = {
  APP: TEXTS.PLAYER_CHANGE_DEVICE_TYPE_APPLICATION,
  WEB: TEXTS.PLAYER_CHANGE_DEVICE_TYPE_WEB,
};

export const DROPDOWN_PLACEMENT_GAP = 8;
